import { PermissionRequest } from "@p0security/shared/types/permission";

import { useFirestoreDoc } from "../../../../../providers/FirestoreProvider.tsx";

export const useRequest = (id: string) =>
  useFirestoreDoc<PermissionRequest>(`permission-requests/${id}`, {
    tenantAware: true,
  });
